import { render, staticRenderFns } from "./ProductTarif.vue?vue&type=template&id=0d2f6988&"
import script from "./ProductTarif.vue?vue&type=script&lang=js&"
export * from "./ProductTarif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports